import { styled } from "@pigment-css/react";

const Stack = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: theme.managementView.spacing[8],
  minWidth: 0,
}));

const Name = styled("span")(({ theme }) => ({
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: theme.managementView.font.size[16],
  fontWeight: theme.managementView.font.weight[500],
  lineHeight: "20px",
  letterSpacing: theme.managementView.font.letterSpacing.tight,
  color: theme.managementView.colors.neutral[90],
}));

const Line = styled("button")(({ theme }) => ({
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  padding: 0,
  border: "none",
  background: "none",
  cursor: "pointer",
  textAlign: "left",
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[14],
  fontWeight: theme.managementView.font.weight[440],
  lineHeight: "16px",
  color: theme.managementView.colors.neutral[64],
  "&:focus-visible": {
    outline: `2px solid ${theme.managementView.colors.neutral[24]}`,
    outlineOffset: "2px",
  },
}));

interface EmployeeNameCellProps {
  name: string;
  line?: { text: string; onOpen: () => void } | null;
}

export const EmployeeNameCell = ({ name, line }: EmployeeNameCellProps) => (
  <Stack>
    <Name>{name}</Name>
    {line && (
      <Line
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          line.onOpen();
        }}
      >
        {line.text}
      </Line>
    )}
  </Stack>
);
